<template>
	<div class="quickStart">
			<nav-header :navText="headerText" class="mb-3" />
			<b-container class="justify-content-center mb-3 border qs-container">
				<b-row v-if="step1">
					<b-col>
						<b-row>
							<b-col class="text-center pb-3">
								<h3>Welcome - Lets Get Started!</h3>
							</b-col>
						</b-row>
						<b-row>
							<b-col>
							<ul>
								<li>You must select at least one fulfilment type that you wish to offer your customers.</li>
								<li>For each fulfilment type selected you must set the number of slots available per hour. 
								<span v-b-tooltip.hover class="pl-2" title="You will set your business opening hours in step 2" ><b-icon-info-circle-fill></b-icon-info-circle-fill></span>
								</li>
								<li>You must also set the earliest time a slot can be allocated. We recommend at least 2 hours - <span class="pl-1">Why?<span v-b-tooltip.hover class="pl-2" title="Setting the  minimum number to 2 hours guarantees at least 1 hour between the slot being booked and the start time of the selected time slot.  
							For example, if when you go to allocate a slot the time is 13:55 and the minimum hours ahead is set at 1 hour, then the
							customer will recieve a notification advising them that the booked time is between 14:00 & 15:00 (only 5 mins away). Whereas if the minimum hours ahead is set at 2 hours
							the customer will receive a notification advising them that the booked time is between 15:00 & 16:00 ( 1 hour 5 mins away).
							" ><b-icon-info-circle-fill></b-icon-info-circle-fill></span></span>
							</li>
							</ul>									

							</b-col>
						</b-row>
						<b-row>
							<b-col>
								<h6 class="ml-2 mt-4">Select the order fulfilment types you wish to offer</h6>
							</b-col>
						</b-row>
						<b-row>
							<b-form-group class="pl-2 mt-1">
								<b-form-checkbox-group
								id="orderTypesEnabled"
								v-model="orderTypesEnabledSelected"
								:options="orderTypesEnabledOptions"
								name="orderTypesEnabled"
								class="ml-4"
								></b-form-checkbox-group>
							</b-form-group>
						</b-row>
						<b-row class="mt-3">
							<b-col>
								<h6>Select the number of slots available per hour</h6>
							</b-col>
						</b-row>
						<b-row>
							<b-col cols="4" class="pt-2">
								<h6 class="ml-3 d-block">Click&Collect Desk</h6>
								<b-form-input v-model='form.numberCCSlots'  type="number" class='ml-3 mb-1 d-block w-25' min="1" size='sm' :disabled="numberCCSlotsDisabled"></b-form-input>
							</b-col>
							<b-col cols="4" class="pl-4 pt-2">
								<h6 class="ml-3 d-block">Click&Collect Locker</h6>
								<b-form-input v-model='form.numberLSlots'  type="number" class='ml-3 mb-1 d-block w-25' min="1" size='sm' :disabled="numberLSlotsDisabled"></b-form-input>
							</b-col>
							<b-col cols="4" class="pl-4 pt-2">
								<h6 class="ml-3 d-block">Delivery</h6>
								<b-form-input v-model='form.numberDSlots'  type="number" class='ml-3 mb-1 d-block w-25' min="1" size='sm' :disabled="numberDSlotsDisabled"></b-form-input>
							</b-col>
						</b-row>
						<b-row class="mt-4 pt-1">
							<b-col class="">
								<h6>Set the minimum number of hours ahead a slot can be booked:</h6>
							</b-col>
						</b-row>
						<b-row class="">
							<b-col cols="4" class="pt-2">
								<b-form-input v-model='form.offsetCCSlots'  type="number" class='ml-3 mb-1 d-block w-25' min="1" size='sm' :disabled="offsetCCSlotsDisabled"></b-form-input>
							</b-col>
							<b-col cols="2" class="pl-4 pt-2 d-none">
								<h6 class="ml-3 d-block">Locker Slots</h6>
								<b-form-input v-model='form.offsetLSlots'  type="number" class='ml-3 mb-1 d-block' min="1" size='sm' :disabled="offsetLSlotsDisabled"></b-form-input>
							</b-col>
							<b-col cols="2" class="pl-4 pt-2 d-none">
								<h6 class="ml-3 d-block">Delivery Slots</h6>
								<b-form-input v-model='form.offsetDSlots'  type="number" class='ml-3 mb-1 d-block' min="1" size='sm' :disabled="offsetDSlotsDisabled"></b-form-input>
							</b-col>								
						</b-row>
					</b-col>
				</b-row>
				<b-row v-if="step2">
					<b-col>
						<b-row>
							<b-col class="">
								<ul>
									<li>To get started please set the earliest and latest time possible times a slot can be allocated, remember that this is the start time for the collection / delivery period.
										<span v-b-tooltip.hover class="pl-2" title="For example setting a core end hour of 5pm will mean that the customer receives a text message confirming that
										their order is available for collection (or will be delivered) between 5pm to 6pm on the selected day." ><b-icon-info-circle-fill></b-icon-info-circle-fill></span>
								</li>
									<li>If necessary, as soon as you have completed this quick start, you will be able to quickly and easily fine tune the core hours start and end times by fulfilment type and by day.</li>
								</ul>
							</b-col>
						</b-row>
						<b-row>
							<b-col>
								<h6 class="ml-2 mt-1">Set the core hours (first and last slot start times)</h6>
							</b-col>
						</b-row>
						<b-row class="mt-2 ml-1">
							<b-col>
								<b-form-group label-cols="4" label-cols-lg="4" label-size="sm" label="Core start hour:" label-for="input-sm" class="mt-3">
									<b-form-select v-model="form.startSelected" :options="startSlotOptions" size="sm" class="w-25"></b-form-select>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row class="ml-1">
							<b-col>
								<b-form-group label-cols="3" label-cols-lg="4" label-size="sm" label="Core End hour:" label-for="input-sm">
									<b-form-select v-model="form.endSelected" :options="endSlotOptions" size="sm" class="w-25"></b-form-select>
								</b-form-group>
							</b-col>
						</b-row>						
					</b-col>
				</b-row>
				<b-row v-if="step3">
					<b-col>
						<b-row>
							<b-col class="pb-3">
								<ul>
									<li>Every order that you add to the Scan&Get Order&Collect system will automatically send a text message to your customer
									confirming the date and time of the slot allocated to them.  To identify your business to your customer when they receive the text, it is necessary that
									you specify a display name for your business that is between 2 and 11 characters long (letters and numbers only with no spaces).</li>
									<li>You can add additonal custom text to the confirmation text message in the settings section of your admin panel that will be available after you have
									completed these set up steps.</li>
								</ul>
							</b-col>
						</b-row>
						<b-row>
							<b-col>
								<h6 class="ml-2 mt-1">SMS / Text Business Display Name</h6>
							</b-col>
						</b-row>
						<b-row>
							<b-col class="pt-2">
								<span class="pl-4">Business Shortname <small>(letters & numbers only without spaces)</small>: 
								<!--<span v-b-tooltip.hover class="pl-2" title="Can only contain letters and numbers - no spaces or special characters" ><b-icon-info-circle-fill></b-icon-info-circle-fill></span>--></span>										
							</b-col>
							<b-col class="">
								<b-form-input v-model='form.storeShortName' type="text" class='w-50' size='sm' maxlength="11"></b-form-input>	
								<span class="charCount">Characters: {{ form.storeShortName.length }}</span><br/><span v-if="invalidShortname" class="text-danger"><small>Only letters & numbers without spaces allowed</small></span>
							</b-col>
						</b-row>
					</b-col>
				</b-row>
				<b-row v-if="step4">
					<b-col>
						<b-row>
							<b-col class="pb-3">
								<ul>
									<li>Fantastic! That's it.  You are now ready to start using Scan&Get Order&Collect.</li>
									<li>Remember that it is possible to fine tune and customise a number of options in the settings area of the admin panel.</li>
								</ul>
							</b-col>
						</b-row>
						<b-row>
							<b-col>
								<h6 class="ml-2 mt-1">Review and Confirm</h6>
							</b-col>
						</b-row>
						<b-row>
							<b-col class="pl-4">
								<b-row>
									<b-col class="pl-4 mt-2 mb-4">
										<table class="tbl-review">
											<tr class="review">
												<td class="review-label">
													Click&Collect Enabled
												</td>
												<td class="review-text">
													{{ this.form.clickandcollectEnabled | boolFilter }}
												</td>
												<td class="review-label">
													Number of slots
												</td>
												<td class="review-text">
													{{ this.form.numberCCSlots | boolNaFilter }}
												</td>
											</tr>	
											<tr class="review">
												<td class="review-label">
													Lockers Enabled
												</td>
												<td class="review-text">
													{{ this.form.lockerEnabled  | boolFilter }}
												</td>
												<td class="review-label">
													Number of slots
												</td>
												<td class="review-text">
													{{ this.form.numberLSlots | boolNaFilter }}
												</td>
											</tr>	
											<tr class="review">
												<td class="review-label">
													Delivery Enabled
												</td>
												<td class="review-text">
													{{ this.form.deliveryEnabled | boolFilter }}
												</td>
												<td class="review-label">
													Number of slots
												</td>
												<td class="review-text">
													{{ this.form.numberDSlots | boolNaFilter }}
												</td>
											</tr>	
											<tr class="review">
												<td class="review-label">
													Number of hours ahead
												</td>
												<td class="review-text">
													{{ this.form.offsetCCSlots }}
												</td>
												<td class="review-label">
													
												</td>
												<td class="review-text">
												
												</td>
											</tr>		
											<tr class="review">
												<td class="review-label">
													Start Hour:
												</td>
												<td class="review-text">
													{{ this.form.startSelected }}:00
												</td>
											</tr>
											<tr class="review">
												<td class="review-label">
													End Hour:
												</td>
												<td class="review-text">
													{{ this.form.endSelected}}:00
												</td>
											</tr>
											<tr class="review">
												<td class="review-label">
													Business short name
												</td>
												<td class="review-text">
													{{ this.form.storeShortName }}
												</td>
												<td col-span="2" class="pl-4">
												
		<b-button :variant="confirmBtnVariant" block size="sm" class="" @click="confirmSettings()"><span :class="confirmBtnText">Confirm</span><span :class="confirmBtnSpinner" ><b-spinner h6 ></b-spinner> Saving changes...</span></b-button>										
											
												
												</td>
											</tr>
										</table>
									</b-col>
								</b-row>
							</b-col>
						</b-row>
					</b-col>
				</b-row>
				<b-row class="pt-4">
					<b-col>
						<b-button class="float-left" @click="buttonNav('back')" variant="link" v-if="!step1"> Back</b-button>
					</b-col>
					<b-col class="text-center">
													<h6>Step {{stepInt}} of 4</h6>
					</b-col>
					<b-col>
						<b-button class="float-right" @click="buttonNav('next')" variant="link" v-if="!step4" :disabled="nextDisabled">Next </b-button>
					</b-col>
				</b-row>
			</b-container>
	</div>
</template>
<script>
import {mixin} from '../mixins/clickAndCollectMixins'
import {RepositoryFactory} from '../api/RepositoryFactory'
import NavHeader from './NavHeader'
const SettingsRepoPost = RepositoryFactory.post('settings')
export default{
	name: 'QuickStart',
	components: {NavHeader},
	mixins: [mixin],
	props: ['storeId', 'sectoken', 'subscriptionType'],
	data(){
		return{
			headerText: "Welcome",
			step1: true, // fulfilment types
			step2: false, // fulfilment types
			step3: false, // fulfilment types
			step4: false, // fulfilment types
			currentStep: "step1",
			nextDisabled: true,
			invalidShortname: false,
			stepInt: 1,
			viewTypeSelected: 'clickandcollect',
			orderTypesEnabledSelected: null,
			numberCCSlotsDisabled: true,
			numberLSlotsDisabled: true,
			numberDSlotsDisabled: true,
			offsetCCSlotsDisabled: false,
			offsetLSlotsDisabled: true,
			offsetDSlotsDisabled: true,
			orderTypesEnabledOptions: [
				{value: "clickandcollect", text : "Click&Collect Desk" },
				{value: "locker", text : "Locker" },
				{value: "delivery", text : "Delivery"}
			],
			form : {
				numberCCSlots: 0,
				numberLSlots: 0,
				numberDSlots:0,
				offsetCCSlots: 2,
				offsetLSlots: 2,
				offsetDSlots:2,
				clickandcollectEnabled: 0,
				lockerEnabled: 0,
				deliveryEnabled: 0,
				startSelected: 9,
				endSelected: 17,
				storeShortName: ""			
			},
			confirmBtnVariant: 'primary',
			confirmBtnText: '',
			confirmBtnSpinner: 'd-none',
		}
	},
	created(){
		console.log(this.sectoken)
		console.log(this.storeId)
	},
	methods: {
		async confirmSettings(){
		var payload = new FormData();
		var sgpayload = new FormData();
		var settings = [];
					
					settings.push({ key: 'clickandcollectEnabled', value : this.form.clickandcollectEnabled })
					settings.push({ key: 'lockerEnabled', value : this.form.lockerEnabled})
					settings.push({ key: 'deliveryEnabled' , value : this.form.deliveryEnabled})				
					settings.push({ key: 'storeShortName' , value : this.form.storeShortName})				
					settings.push({ key: 'availableSlots', value : this.form.numberCCSlots })
					settings.push({ key: 'availableLockers', value : this.form.numberLSlots})
					settings.push({ key: 'deliverySlots' , value : this.form.numberDSlots})				
					settings.push({ key: 'sameDayOffset' , value : this.form.offsetCCSlots})				
					settings.push({ key: 'startSelectedDesk', value : this.form.startSelected})
					settings.push({ key: 'startSelectedLocker' , value : this.form.startSelected})				
					settings.push({ key: 'startSelectedDelivery' , value : this.form.startSelected})				
					settings.push({ key: 'endSelectedDesk', value : this.form.endSelected})
					settings.push({ key: 'endSelectedLocker' , value : this.form.endSelected})				
					settings.push({ key: 'endSelectedDelivery' , value : this.form.endSelected})				
					payload.append('storeId', this.storeId)			
					payload.append('settings', JSON.stringify(settings));
					
					sgpayload.append('storeId', this.storeId)
					sgpayload.append('setting', 'strClickAndCollect')
					sgpayload.append('newValue', 'active')
					
					await SettingsRepoPost.postUpdateStoreSettingsQS(payload)
					await SettingsRepoPost.postUpdateSgSetting(sgpayload)
					
					this.confirmBtnVariant = 'outline-success';
					this.confirmBtnText = 'd-none';
					this.confirmBtnSpinner = ''	;	
					setTimeout(() => {
						this.confirmBtnVariant = '';
						this.confirmBtnText = '';
						this.confirmBtnSpinner = 'd-none';
						window.location = ('/orderCollect/' + this.sectoken +'/' + this.storeId + '/' + this.subscriptionType)
					}, 3000);
		},
		buttonNav(direction){
			switch(this.currentStep)
			{
				case "step1":
				this.currentStep = "step2";
				this.step1 = false
				this.step2 = true
				this.stepInt = 2
				break;
				case "step2":
				if(direction == "next")
				{
					this.currentStep = "step3";
					this.step2 = false
					this.step3 = true
					this.nextDisabled = (this.form.storeShortName.length == 0 || this.invalidShortname)? true : false
					this.stepInt = 3
				}
				else
				{
					this.currentStep = "step1";
					this.step2 = false
					this.step1 = true	
					this.stepInt = 1					
				}
				break;
				case "step3":
				if(direction == "next")
				{
					this.currentStep = "step4";
					this.step3 = false
					this.step4 = true
					this.stepInt = 4
				}
				else
				{
					this.currentStep = "step2";
					this.step3 = false
					this.step2 = true
					this.stepInt = 2	
					this.nextDisabled =  false					
				}
				break;
				case "step4":
				this.currentStep = "step3";
				this.step4 = false
				this.step3 = true
				this.stepInt = 3
				break;
			}
		},
		disableOption(index, type){
			let disabledState;
			if(type == 'start')
			{
				disabledState = (index > this.form.endSelected)? true : false
			}
			else
			{
				disabledState = (index < this.form.startSelected)? true : false
			}		 
			return disabledState
		},
	},
	watch:{
		form: {
			handler(newVal){
				if(this.step3)
				{
					// use a mixin regex function to ensure string only contains letters and numbers with no spaces
					if(this.isLetterNumber(newVal.storeShortName))
					{
						this.nextDisabled = (newVal.storeShortName.length <= 1)? true : false	
						this.invalidShortname =  false			
					}
					else
					{ 
						this.nextDisabled =  true
						this.invalidShortname = true
					}
				}
			},
			deep: true
		},
		orderTypesEnabledSelected(newVal)
		{
			console.log(newVal)
			this.nextDisabled = (newVal.length >=1)? false : true;
			let clickandcollectSelected = newVal.filter((item)=> item == 'clickandcollect')
			this.numberCCSlotsDisabled = (clickandcollectSelected.length >= 1)? false : true;
			let lockerSelected = newVal.filter((item)=> item == 'locker')
			this.numberLSlotsDisabled = (lockerSelected.length >= 1)? false : true;
			let deliverySelected = newVal.filter((item)=> item == 'delivery')
			this.numberDSlotsDisabled = (deliverySelected.length >= 1)? false : true;	
			this.form.clickandcollectEnabled =(this.orderTypesEnabledSelected.includes('clickandcollect'))? 1 : 0
			
			this.form.lockerEnabled =(this.orderTypesEnabledSelected.includes('locker'))? 1 : 0
			this.form.deliveryEnabled =(this.orderTypesEnabledSelected.includes('delivery'))? 1: 0	
			
			// ensure that at least 1 slots is available or zero if a fulfilment type is not selected
			this.form.numberCCSlots = (newVal.includes('clickandcollect') )? (this.form.numberCCSlots == 0)? 1: this.form.numberCCSlots : 0			
			this.form.numberLSlots = (newVal.includes('locker') )? (this.form.numberLSlots == 0)? 1: this.form.numberLSlots : 0
			this.form.numberDSlots = (newVal.includes('delivery') )? (this.form.numberDSlots == 0)? 1: this.form.numberDSlots : 0
			
			console.log(this.form)
		}
	},
	computed:{
		endSlotOptions(){
			let options =  [
			{ value : 1, text: '1:00 am', disabled : this.disableOption(1, 'end')},
			{ value : 2, text: '2:00 am', disabled : this.disableOption(2, 'end')},
			{ value : 3, text: '3:00 am', disabled : this.disableOption(3, 'end')},
			{ value : 4, text: '4:00 am', disabled : this.disableOption(4, 'end')},
			{ value : 5, text: '5:00 am', disabled : this.disableOption(5, 'end')},
			{ value : 6, text: '6:00 am', disabled : this.disableOption(6, 'end')},
			{ value : 7, text: '7:00 am', disabled : this.disableOption(7, 'end')},
			{ value : 8, text: '8:00 am', disabled : this.disableOption(8, 'end')},
			{ value : 9, text: '9:00 am', disabled : this.disableOption(9, 'end')},
			{ value : 10, text: '10:00 am', disabled : this.disableOption(10, 'end')},
			{ value : 11, text: '11:00 am', disabled : this.disableOption(11, 'end')},
			{ value : 12, text: '12:00 pm', disabled : this.disableOption(12, 'end')},
			{ value : 13, text: '1:00 pm', disabled : this.disableOption(13, 'end')},
			{ value : 14, text: '2:00 pm', disabled : this.disableOption(14, 'end')},
			{ value : 15, text: '3:00 pm', disabled : this.disableOption(15, 'end')},
			{ value : 16, text: '4:00 pm', disabled : this.disableOption(16, 'end')},
			{ value : 17, text: '5:00 pm', disabled : this.disableOption(17, 'end')},
			{ value : 18, text: '6:00 pm', disabled : this.disableOption(18, 'end')},
			{ value : 19, text: '7:00 pm', disabled : this.disableOption(19, 'end')},
			{ value : 20, text: '8:00 pm', disabled : this.disableOption(20, 'end')},
			{ value : 21, text: '9:00 pm', disabled : this.disableOption(21, 'end')},
			{ value : 22, text: '10:00 pm', disabled : this.disableOption(22, 'end')},
			{ value : 23, text: '11:00 pm', disabled : this.disableOption(23, 'end')},
			{ value : 24, text: '12:00 am', disabled : this.disableOption(24, 'end')}
			]
			return options
		},
		startSlotOptions(){
		let options =  [
		{ value : 1, text: '1:00 am', disabled : this.disableOption(1, 'start')},
		{ value : 2, text: '2:00 am', disabled : this.disableOption(2, 'start')},
		{ value : 3, text: '3:00 am', disabled : this.disableOption(3, 'start')},
		{ value : 4, text: '4:00 am', disabled : this.disableOption(4, 'start')},
		{ value : 5, text: '5:00 am', disabled : this.disableOption(5, 'start')},
		{ value : 6, text: '6:00 am', disabled : this.disableOption(6, 'start')},
		{ value : 7, text: '7:00 am', disabled : this.disableOption(7, 'start')},
		{ value : 8, text: '8:00 am', disabled : this.disableOption(8, 'start')},
		{ value : 9, text: '9:00 am', disabled : this.disableOption(9, 'start')},
		{ value : 10, text: '10:00 am', disabled : this.disableOption(10, 'start')},
		{ value : 11, text: '11:00 am', disabled : this.disableOption(11, 'start')},
		{ value : 12, text: '12:00 pm', disabled : this.disableOption(12, 'start')},
		{ value : 13, text: '1:00 pm', disabled : this.disableOption(13, 'start')},
		{ value : 14, text: '2:00 pm', disabled : this.disableOption(14, 'start')},
		{ value : 15, text: '3:00 pm', disabled : this.disableOption(15, 'start')},
		{ value : 16, text: '4:00 pm', disabled : this.disableOption(16, 'start')},
		{ value : 17, text: '5:00 pm', disabled : this.disableOption(17, 'start')},
		{ value : 18, text: '6:00 pm', disabled : this.disableOption(18, 'start')},
		{ value : 19, text: '7:00 pm', disabled : this.disableOption(19, 'start')},
		{ value : 20, text: '8:00 pm', disabled : this.disableOption(20, 'start')},
		{ value : 21, text: '9:00 pm', disabled : this.disableOption(21, 'start')},
		{ value : 22, text: '10:00 pm', disabled : this.disableOption(22, 'start')},
		{ value : 23, text: '11:00 pm', disabled : this.disableOption(23, 'start')},
		{ value : 24, text: '12:00 am', disabled : this.disableOption(24, 'start')}
		]
		return options
		}
	},
	filters:{
		testFilter: function(value){
			
			return value
		}
	},
}

</script>
<style scoped>
h6{
font-weight: bold;
}
td.review-label {

    font-weight: bold;
    color: #21252999
  
}

td.review-text{
  text-align: left

}


table.tbl-review {
  width: 80%
     
}

td{
padding: 5px;
border: 1px solid #fffff
}

.charCount{
	font-size: 0.8em;
}
.qs-container{
width: 900px;
margin-top: 75px;
padding: 40px 25px 0px 25px;
}
</style>